import { useState } from "react"
import { CommaFire } from "../CommaFire"

export declare type InputProps = {
    name?: string,
    errorMessage?: string,
    custom_class?: string,
    checked?: boolean ,
    defaultChecked?:boolean ,
    onChange?:(e: string) => any;
}

export const CToggle = ({ name, errorMessage, custom_class, checked , onChange , defaultChecked }: InputProps) => {

    const handelOnchange=(e:any)=>{
        onChange?.(e)
    }

    return (
        <label className="table-toggle">
            <>
                <input name={name} type="checkbox" onChange={(e:any)=>handelOnchange(e)} checked={checked} defaultChecked={defaultChecked?defaultChecked:false} />
                <div className="table-toggle-main" />
            </>
        </label>
    );
}